import React, { ReactElement } from 'react'
import { UserType } from '@types'
import { formatLong } from '@utils/date-utils'

interface Props {
  user: UserType
}

const dateTimeRegex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{6}Z$/

const stringOrDateTimeFormat = (value: any) => {
  const stringValue = String(value)
  if (dateTimeRegex.test(stringValue)) {
    return formatLong(stringValue)
  }
  return stringValue
}

const DemographicsChanges = ({
  user: { activity_log },
}: Props): ReactElement => {
  if (!activity_log || !activity_log.length) {
    return <p>No demographic changes logged yet</p>
  }

  return (
    <ul>
      {activity_log.map((activity, i) => (
        <li key={i}>
          <p>
            <i>{activity.event}</i> &mdash; {formatLong(activity.created_at)}
          </p>
          <div>
            <ul>
              {Object.entries(activity.properties.attributes).map(
                ([key, value], i) => (
                  <li key={i}>
                    {key}: {stringOrDateTimeFormat(value)}
                  </li>
                ),
              )}
            </ul>
          </div>
        </li>
      ))}
    </ul>
  )
}

export default DemographicsChanges
